import { render, staticRenderFns } from "./PayView.vue?vue&type=template&id=466bc0c2&scoped=true"
import script from "./PayView.vue?vue&type=script&lang=js"
export * from "./PayView.vue?vue&type=script&lang=js"
import style0 from "./PayView.vue?vue&type=style&index=0&id=466bc0c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466bc0c2",
  null
  
)

export default component.exports